export default __webpack_public_path__ + "0ab90c40f71c67e73f1724cd072645f2.svg";